import { useEffect, useState } from "react";
import api, { apiError } from "../lib/api";
import { useFlash } from "../lib/flash";

const fmt = (iso) => new Date(iso).toLocaleString("da-DK", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

function Row({ r, onToggle }) {
  const [open, setOpen] = useState(false);
  const done = r.status === "resolved";
  return (
    <>
      <tr data-testid={`owner-support-row-${r.id}`}>
        <td><small>{fmt(r.created_at)}</small></td>
        <td>{r.store_label || "–"}{r.store_id ? <small className="muted"> #{r.store_id}</small> : null}</td>
        <td>{r.topic}</td>
        <td><a href={`mailto:${r.email}`}>{r.name}</a><br /><small className="muted">{r.email}</small></td>
        <td>
          <button type="button" className="btn small" onClick={() => setOpen((o) => !o)} data-testid={`owner-support-view-${r.id}`}>{open ? "Skjul" : "Vis"}</button>
        </td>
        <td>
          <button type="button" className={"pill " + (done ? "" : "warn")} style={{ border: 0, cursor: "pointer" }}
            onClick={() => onToggle(r)} data-testid={`owner-support-status-${r.id}`}>{done ? "Løst" : "Åben"}</button>
        </td>
      </tr>
      {open && (
        <tr><td colSpan={6} style={{ whiteSpace: "pre-wrap", background: "var(--paper)" }} data-testid={`owner-support-message-${r.id}`}>{r.message}</td></tr>
      )}
    </>
  );
}

export default function OwnerSupport() {
  const [d, setD] = useState(null);
  const flash = useFlash();
  const load = () => api.get("/owner/support").then((r) => setD(r.data)).catch(() => setD({ requests: [], open: 0, err: true }));
  useEffect(() => { load(); }, []);
  const toggle = async (r) => {
    try {
      await api.post(`/owner/support/${r.id}/status`, { status: r.status === "resolved" ? "open" : "resolved" });
      load();
    } catch (e) {
      flash(apiError(e.response?.data?.detail), "error");
    }
  };
  if (!d) return null;
  return (
    <section className="panel" data-testid="owner-support">
      <h2>Support <span className="pill warn" data-testid="owner-support-open">{d.open} åbne</span></h2>
      {d.err && <p className="muted">Kunne ikke hente henvendelser.</p>}
      {!d.requests.length ? <p className="muted" data-testid="owner-support-empty">Ingen henvendelser endnu.</p> : (
        <div className="table-wrap">
          <table data-testid="owner-support-table">
            <thead><tr><th>Dato</th><th>Butik</th><th>Emne</th><th>Afsender</th><th>Besked</th><th>Status</th></tr></thead>
            <tbody>{d.requests.map((r) => <Row key={r.id} r={r} onToggle={toggle} />)}</tbody>
          </table>
        </div>
      )}
    </section>
  );
}
